<template>
  <Form ref="housingForm" :model="housing" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="housing.id" type="hidden"/>

    <FormItem  :label="this.$t('property.housing.housingNo.label')" prop="housingNo">
      <Input v-model="housing.housingNo" :placeholder="$t('property.housing.housingNo.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('property.housing.name.label')" prop="name">
      <Input v-model="housing.name" :placeholder="$t('property.housing.name.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('property.housing.area.label')" prop="area">
      <Input v-model="housing.area" :placeholder="$t('property.housing.area.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('property.housing.remark.label')" prop="remark">
      <Input v-model="housing.remark" :placeholder="$t('property.housing.remark.holder')"/>
    </FormItem>

    <div v-if="actionType=='detail'">
      <FormItem  :label="this.$t('property.housing.createTime.label')"  prop="createTime">
        <Date-picker v-model="housing.createTime" disabled type="datetime"  :placeholder="this.$t('property.housing.createTime.holder')"></Date-picker>
      </FormItem>
    </div>
  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      housing: {
        id: null,
        housingNo: null,
        name: null,
        area: null,
        remark: null
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['housingForm'].validate(valid => {
        if (valid) {
          if (this.housing.id) {
            this.updateHousing(this.housing).then(then).error(error)
          } else {
            this.createHousing(this.housing).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.housing.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['housingForm'].resetFields());
    },
    getHousing(id,type){
      this.loading = true;
      this.$refs['housingForm'].resetFields()
      api.property.Housing.detail(id).then(data => {
        this.housing = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createHousing(housing){
      this.loading = true;
      return api.property.Housing.add(housing)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateHousing(housing){
      this.loading = true;
      return api.property.Housing.update(housing)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      housingNo: [{type: 'string', required: true, message: this.$t('property.housing.housingNo.required'),trigger: 'blur'}, {type: 'string',max: 80, message: this.$t('property.housing.housingNo.max'),trigger: 'blur'}],
      name: [{type: 'string', required: true, message: this.$t('property.housing.name.required'),trigger: 'blur'}, {type: 'string',max: 30, message: this.$t('property.housing.name.max'),trigger: 'blur'}],
      area: [{type: 'string',max: 30, message: this.$t('property.housing.area.max'),trigger: 'blur'}],
      remark: [{type: 'string',max: 255, message: this.$t('property.housing.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['housingForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
